export const SESSION_CONFIG = {
  SHORT_SESSION: 15 * 60 * 1000,
  EXTENDED_SESSION: 30 * 24 * 60 * 60 * 1000,
};

export const AUTH_STEPS = {
  EMAIL: 'email',
  OTP: 'otp',
  PASSWORD: 'password',
  SIGNUP: 'signup',
  REGISTRATION: 'registration',
  FORGOT_PASSWORD: 'forgot_password'
};

export const LOADING_STATES = {
  IDLE: 'idle',
  EMAIL: 'email',
  OTP: 'otp',
  PASSWORD: 'password',
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
  SIGNUP: 'signup',
  REGISTRATION: 'registration',
  FORGOT_PASSWORD: 'forgot_password'
};

export const WEBSITE_PLATFORMS = [
  { value: "wordpress", label: "WordPress" },
  { value: "webflow", label: "Webflow" },
  { value: "wix", label: "Wix" },
  { value: "squarespace", label: "Squarespace" },
  { value: "custom", label: "Others" },
];

export const STORAGE_KEYS = {
  REFERRAL_CODE: 'referral_code',
  INSTALL_SOURCE: 'install_source',
  ROLE: 'role',
  REMEMBER_ME: 'rememberMe',
  SESSION_CONFIG: 'sessionConfig',
  SHOW_STAY_LOGGED_IN_PROMPT: 'showStayLoggedInPrompt',
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data'
};

export const PASSWORD_RULES = {
  MIN_LENGTH: 8,
  REQUIRES_LETTER: true,
  REQUIRES_UPPERCASE: true,
  REQUIRES_LOWERCASE: true,
  REQUIRES_NUMBER: true,
  REQUIRES_SPECIAL: true
};